<template>
    <div class="left-nav">
        <v-navigation-drawer
                app
                color="grey_light"
                v-model="sidebar.opened"
                :mini-variant="miniVariant"
                :width="navigationWidth"

        >
            <div v-if="websites" style="min-height: 100%; background-color: white;" class="d-flex flex-column justify-start pl-4 pr-4">
                <div class="d-flex justify-center align-center flex-wrap" v-if="!isAdmin">
                    <v-btn color="transparent" v-if="(websites.length == 0 || activeWebsite == null) && !isAdmin" to="/websites/create" class="w-100">
                        <v-icon>mdi-plus</v-icon>
                        Add new website
                    </v-btn>
                    <div class="d-flex justify-center align-center flex-wrap w-100 mt-10 mb-10" v-else>
                        <v-img v-if="activeWebsite.header && activeWebsite.header.data && activeWebsite.header.data.image" width="64px" height="64px" contain :src="activeWebsite.header.data.image"></v-img>
                    </div>
                </div>
                <div class="d-flex justify-center align-center flex-wrap" v-else>
                    <div class="d-flex justify-center align-center flex-wrap w-100 mt-10 mb-10">
                        <v-img width="64px" height="64px" contain :src="$root.getSrc(logo)"></v-img>
                    </div>
                </div>

                <v-select v-if="!isAdmin" return-object :menu-props="{'offset-y': true}" @change="setActiveWebsite" v-model="activeWebsite" dense outlined item-text="name" :items="websites"></v-select>

                <div v-if="activeWebsite && !isAdmin" @click="openActiveWebsite" style="border-radius: 6px" class="hover d-flex flex-row justify-center align-center">
                    <span class="fs-16 fw-400">Go To Store</span>
                </div>


                <div>
                    <v-list class="mt-5" dense>
                        <v-list-item-group
                                v-for="(item,index) in menu_items"
                                :key="item.text"
                                v-if="item.visible && checkItem(item)">
                            <v-list-item v-ripple="false" class="my-5" :target="(item.target)? item.target : null" :class="(item.classes)? item.classes : ''" v-if="!item.items && item.type != 'subtitle' && item.to" exact :to="(item.to && !item.items)? item.to : null">
                                <v-list-item-title class="ml-5 d-flex flex-row justify-start align-center" style="z-index: 1;">
                                    <img width="32px" height="32px" style="object-fit: contain" :src="$root.getSrc('default/drop_icons/'+item.icon+'_blue.svg')">
                                    <span class="fs-18 fw-500 ml-4">{{$t(item.text)}}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item :target="(item.target)? item.target : null"  class="my-5" :class="(item.classes)? item.classes : ''" v-else exact :href="(item.to_blank && !item.items)? item.to_blank : null">
                                <v-list-item-title style="z-index: 1; display: flex; flex-direction: column; align-items: center">
                                    <v-img v-if="item.icon" width="35px" height="35px" contain :src="item.icon"></v-img><v-icon style="font-size: 35px;" v-else>{{item.icon_mdi}}</v-icon>
                                    {{$t(item.text)}}
                                </v-list-item-title>
                            </v-list-item>
                            <v-divider v-if="index == 4 || index == 9"></v-divider>
                        </v-list-item-group>
                    </v-list>

                    <div class="align-center d-flex flex-column mt-10 drop-btn" v-if="!isAdmin">
                        <v-btn v-ripple="false" height="48px" width="90%"  class="blue--text drop-button button-secondary-active" to="/websites/create">Create new store</v-btn>
                    </div>
                    <div class="align-center d-flex flex-column mt-16 drop-btn" v-else>
                        <v-btn v-ripple="false" color="#2F80ED"  height="48px" width="90%" class="white--text drop-button button-primary-active" >{{$t('Add new admin')}}</v-btn>
                    </div>

                </div>
                <div class="my-5 d-flex align-center justify-center">
                    <router-link to="/">
                        <v-img v-if="!sidebar.opened" max-height="55px" max-width="120px" :src="$root.getSrc(logo)" alt="Drop" />
                        <v-img v-if="sidebar.opened" :src="$root.getSrc(logo)" class="mt-2" max-height="55px" max-width="120px" contain alt="Drop" />
                    </router-link>
                </div>
            </div>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import store from '../../store/index'
    export default {
        props:['open'],
        data(){
            return{
                refresh: false,
                drawer: false,
                items: [
                    { icon: 'dashboard', text: 'Dashboard', to: '/', visible: true},
                    { icon: 'products', text: 'Products', to:'/products', visible: true},
                    { icon: 'orders', text: 'Orders', to:'/orders', visible: true},
                    { icon: 'coupons', text: 'Coupons', to:'/coupons', visible: !this.isAdmin},

                    { icon: 'users_group', text: 'Users', to:'/users', visible: this.isAdmin},
                    { icon: 'store', text: 'Stores', to:'/stores', visible: this.isAdmin},
                    { icon: 'store', text: 'Websites', to:'/websites', visible: !this.isAdmin},

                    { icon: 'payments', text: 'Payment', to:'/payments', visible: true},
                    { icon: 'integration', text: 'Integration', to:'/integration', visible: !this.isAdmin},

                    { icon: 'myfiles', text:  !this.isAdmin ? 'My files' : 'Files', to:'/files', visible: false},
                    { icon: 'support', text: 'Support', to:'/support', visible: true},
                ],
            }
        },
        computed:{
            menu_items(){
                var items = Object.assign([], this.items);
                if(this.activeWebsite && !this.items.find(x => x.text == 'Page layout')){
                    items.splice(3, 0, { icon: 'store_design', text: 'Store design', to:'/websites/design', visible: !this.isAdmin});
                    // items.splice(7, 0, {icon: this.$root.getSrc('/default/gear.png'), text: 'Settings', to:'/websites/'+this.getActiveWebsiteId(), visible: true});
                }
                return items;
            },
            isAdmin(){
                return this.$store.getters.user && this.$store.getters.user.website_role && this.$store.getters.user.website_role.name == 'admin';
            },
            navigationWidth(){
                if(this.$vuetify.breakpoint.xlOnly) return '300px';
                if(this.$vuetify.breakpoint.lgAndUp) return '280px';
                if(this.$vuetify.breakpoint.mdAndUp) return '250px';
                return '250px';
            },
            logo(){
                return this.$store.getters.admin_logo;
            },
            websites(){
                return this.$store.getters.websites
            },
            activeWebsite(){
                return this.$store.getters.activeWebsite
            },
            user() {return this.$store.getters.user},
            activeSellout() {return (this.$store.getters.activeSellout)? this.$store.getters.activeSellout : {}},
            sidebar() {
                return this.$store.getters.sidebar;
            },
            miniVariant(){return this.$store.getters.sidebar.miniVariant},
        },
        mounted(){
            this.$root.$eventBus.$on('refreshSidebar', () => {

                this.refresh = true;
                setTimeout(() => {
                    this.refresh = false;
                },100)
            })
        },
        methods:{
            goToFaq(){
                window.open(this.$root.base_url+'/page/faq', '_blank');
            },
            getActiveWebsiteId(){
                if(this.activeWebsite){
                    return this.activeWebsite.id
                }else{
                    return 0;
                }
            },
            getActiveWebsiteLink(){
                if(this.activeWebsite){
                    return this.activeWebsite.link
                }else{
                    return 0;
                }
            },
            checkItem(item){
                if(item.guest && this.user.id) return false;
                if(item.hasPlace){
                    if(!this.user.id) return false
                    return true;
                }else{
                    return true;
                }
            },
            setActiveWebsite(website){
                this.$store.dispatch('websites/setActive', website);
                location.reload();
            },
            openActiveWebsite(){
                window.open(this.activeWebsite.link, '_blank');

            },
        }
    }
</script>
<style lang="scss">
    .v-list-item--active {
        background-color: #2F80ED!important;
        border-radius: 8px!important;
        color: white!important;
        img {
            filter: brightness(100);
        }
    }

    .v-list-item--active span{
        color: white!important;
    }


    .left-nav{
        .v-list-item{
            padding-top: 4px !important;
            padding-bottom: 4px !important;
            .v-list-item__icon{
                margin-right: 18px;
            }
            .v-list-item__title{
                font-weight: 600;
            }
        }
        .v-list-item--link{
            &:before{
                background-color: black;
            }
        }
        .v-list-item--active{
            &:before{
                opacity: 0.1;
            }
        }
        .v-btn--active{
            &:before{
                opacity: 0 !important;
            }
        }
    }
    .theme--light.v-list-item--active:before, .theme--light.v-list-item--active:hover:before, .theme--light.v-list-item:focus:before {
        opacity: 0;
    }
</style>
